import { render } from "./CookiesButton.vue?vue&type=template&id=1e00eb5b&scoped=true&ts=true"
import script from "./CookiesButton.vue?vue&type=script&lang=ts"
export * from "./CookiesButton.vue?vue&type=script&lang=ts"

import "./CookiesButton.vue?vue&type=style&index=0&id=1e00eb5b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e00eb5b"]])

export default __exports__